
import { post } from '@/utils/http'

// 获取泡泡列表 我发出的泡泡
export const sentOutBlindBox = function (data) {
  return post({
      url: "/app/business/blind/box/selectMySendOutList",
      data
  })
}
// 获取泡泡列表 我收到的泡泡
export const receivedBlindBox = function (data) {
  return post({
      url: "/app/business/blind/box/join/record/selectMyOpenList",
      data
  })
}
//  我发出的-详情
export const getMySendOutInfo = function (data) {
  return post({
      url: "/app/business/blind/box/getMySendOutInfo",
      data
  })
}
// 我开启的获取泡泡详情
export const getMyOpenInfo = function (data) {
  return post({
      url: "/app/business/blind/box/join/record/getMyOpenInfo",
      data
  })
}
// 我发出的-详情-开泡泡用户
export const blindBoxDetailsInfo = function (data) {
  return post({
      url: "/app/business/blind/box/join/record/selectBlindBoxJoinRecordListByBoxId",
      data
  })
}
// 我发出的 删除
export const remove = function (data) {
  return post({
      url: "/app/business/blind/box/remove",
      data
  })
}
// 我开启的 删除泡泡
export const deleteBlindBox = function (data) {
  return post({
      url: "/app/business/blind/box/join/record/remove",
      data
  })
}

// 撤回泡泡
export const withdrawBlindBox = function (data) {
  return post({
      url: "/app/business/blind/box/revoke",
      data
  })
}
// 点赞或取消点赞
export const supportOppose = function (data) {
  return post({
      url: "/app/business/blind/box/support-oppose",
      data
  })
}
// 单身泡泡 我发出的 /app/single/blind/box/selectMySendOutList

export const selectMySendOutList = function (data) {
  return post({
      url: "/app/single/blind/box/selectMySendOutList",
      data
  })
}
// 单身泡泡 我开启的 /app/single/blind/box/join/record/selectMyOpenList
export const selectMyOpenList = function (data) {
  return post({
      url: "/app/single/blind/box/record/selectMyOpenList",
      data
  })
}

// 我发出的详情 /app/single/blind/box/getMySendOutInfo
export const getMySingleSendOutInfo = function (data) {
  return post({
      url: "/app/single/blind/box/getMySendOutInfo",
      data
  })
}
// 我发出的-详情-开泡泡用户  /app/single/blind/box/record/selectPageByBoxId
export const selectPageByBoxId = function (data) {
  return post({
      url: "/app/single/blind/box/record/selectPageByBoxId",
      data
  })
}
// /app/single/blind/box/revoke 撤回泡泡
export const revoke = function (data) {
  return post({
      url: "/app/single/blind/box/revoke",
      data
  })
}
// /app/single/blind/box/remove 删除泡泡
export const singleRemove = function (data) {
  return post({
      url: "/app/single/blind/box/remove",
      data
  })
}
// /app/single/blind/box/join/record/getMyOpenInfo 获取我开启的单身泡泡详情
export const getSingleMyOpenInfo = function (data) {
  return post({
      url: "/app/single/blind/box/record/getMyOpenInfo",
      data
  })
}
// /app/single/blind/box/join/record/remove 删除我开启的单身泡泡

export const singleRemoveMyOpenInfo = function (data) {
  return post({
      url: "/app/single/blind/box/record/remove",
      data
  })
}
// /app/business/blind/box/support-oppose 点赞或取消点赞
export const singleSupportOppose = function (data) {
  return post({
      url: "/app/single/blind/box/support-oppose",
      data
  })
}
// 彩蛋抽奖
export const extractPrize = function (data) {
  return post({
      url: "/app/shop/coupon/extractPrize",
      data
  })
}
// 溜溜壶 苹果树等级
export const getLlhTotal = function (data) {
  return post({
      url: "/app/user/llhTotal",
      data
  })
}